import { render, staticRenderFns } from "./DashboardBonCoupEmail.vue?vue&type=template&id=248f5277&"
import script from "./DashboardBonCoupEmail.vue?vue&type=script&lang=js&"
export * from "./DashboardBonCoupEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports